import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as TablasComunesService from 'services/tablasComunes.service'

const FlujosEfectivoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const [flujosEfectivo, setFlujosEfectivo] = React.useState([])

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.FLUJOSEFECTIVO)
      .then(({ data }) => {
        setFlujosEfectivo(data)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('button-formulariopagos-procesar', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FLUJO E.' htmlFor='select-flujoEfectivo' md={4} />
      <Col md={8}>
        <Field name='flujoEfectivo'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-flujoEfectivo'
              onKeyDown={onKeyDown}
            >
              {flujosEfectivo.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlujosEfectivoFormGroup)
